import { FormApi } from 'final-form'
import React from 'react'

export type TFormContext = { form?: FormApi }

const FormContext = React.createContext<TFormContext>({ form: undefined })

export default FormContext
